export function openEmail(emailAddress, subject = "", content = "") {
    var email = emailAddress;
    var mailSubject = subject;
    var emailBody = content;
    document.location = "mailto:"+ email +"?subject=" + mailSubject + "&body=" + emailBody;
}